import { render, staticRenderFns } from "./EventNavbar.vue?vue&type=template&id=530bc228&"
import script from "./EventNavbar.vue?vue&type=script&lang=js&"
export * from "./EventNavbar.vue?vue&type=script&lang=js&"
import style0 from "./EventNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports